import React, { useContext, useRef, useEffect, useState } from "react";
import ModalFormatos from "../../pages/modalFormatos";
import { BannerContext } from '../../contexts/BannerDimensionsContext';
import LoadFile from "../loadfile";
import Tooltip from '@mui/material/Tooltip';
import './index.css';
import GlobalConfig from "../globalConfig";


function LeftMenu() {
  const {master, fullScreenLeft} = useContext(BannerContext);
  const refNewFile = useRef(null);
  
  function loadHtml() {
    document.getElementById('file-upload-html').click();
  }

  const [divWidth, setDivWidth] = useState('350px')

  useEffect(() => {
    function handleResize() {
      if (!fullScreenLeft) {
        const windowWidth = window.innerWidth;
        if (windowWidth >= 1800) {
          setDivWidth('350px');
        } else if (windowWidth >= 1600) {
          setDivWidth('300px');
        } else if (windowWidth >= 1300) {
          setDivWidth('250px');
        } else if (windowWidth >= 1200) {
          setDivWidth('210px');
        } else {
          setDivWidth('350px');
        }
      }
    }

    handleResize();
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [fullScreenLeft]);
  
  return(
    <div className="containerLeft" style={{width: fullScreenLeft ? '0px' : divWidth, minWidth: fullScreenLeft ? '0px' : divWidth, transition: 'width 500ms'}}>
      <div className="projectNameandNew">
        <span className='projectName'>{master.name.slice(0, -5)}</span>
        <Tooltip title="Novo projeto">
          <img alt='img' src="assets/addbutton.png" style={{cursor: 'pointer'}} onClick={() => loadHtml()}></img>
        </Tooltip>
      </div>
      <span className="categoriasText">Configurações gerais</span>
      <GlobalConfig />    

      <span className="categoriasText">Categorias</span>
      <ModalFormatos/>
      <LoadFile ref={refNewFile}></LoadFile>
    </div>
  )
}

export default LeftMenu;